import * as yup from "yup";
import { t } from "i18next";  
  
  export const schema = yup.object().shape({
    productName: yup
      .string()
      .required(t("responseMessage.productNameRequired")),
    unitOfMeasure: yup.string().required(t("responseMessage.selectAnOption")),
    category: yup.string().required(t("responseMessage.selectAnOption")),
    maxQuantity: yup.string(),
    // .matches(/^[0-9]+$/, "* Invalid variants"),
    productNameInNepali: yup.string().required("Nepali product name is required"),
    // .required(t("responseMessage.neNameRequired")),
    descriptionInNepali: yup.string().required("Nepali description is required"),
    // .required(t("responseMessage.neDescriptionRequired")),
    variants: yup
      .string()
      .required(t("responseMessage.variantsRequired"))
      .matches(/^[0-9]+(\.[0-9]+)?$/, "Invalid variants"),

    priceInNepali: yup
      .string()
      .required(t("responseMessage.priceRequired"))
      .matches(/^[0-9]+(\.[0-9]+)?$/, t("responseMessage.invalidPrice")),

    description: yup
      .string()
      .required(t("responseMessage.descriptionRequired"))
      .matches(
        /^[a-zA-Z0-9\s!@#$%^&*.,()\-]+$/,
        t("responseMessage.addValidDescription")
      ),
    threshold_limit: yup
      .string()
      .required("* Threshold limit is required")
      .matches(/^[0-9]+(\.[0-9]+)?$/, "* Invalid limit"),

    minQuantity: yup
      .string()
      .default("1")
      .required(t("responseMessage.qtyRequired"))
      .matches(/^[0-9]+(\.[0-9]+)?$/, t("responseMessage.invalidQuantity"))
      .test(
        "minQuantity",
        t("responseMessage.minQuantityGreaterThanZero"),
        (value) => {
          return parseFloat(value) > 0;
        }
      ),

    // price: yup
    //   .string()
    //   .required(t("responseMessage.priceRequired"))
    //   .matches(/^[0-9]+(\.[0-9]+)?$/, t("responseMessage.invalidPrice")),

    inventory: yup
      .string()
      .required(t("responseMessage.inventoryRequired"))
      .matches(/^[0-9]+$/, t("responseMessage.invalidInventory")),

    sku: yup.string().required("* Sku is required"),

    productImage: yup.mixed().required("* Product image is required"),

    brand: yup.string().required("* Brand name is required"),
    // brandOwner: yup.string().required("* Brand owner is required"),
    // brandCategory: yup.string().required("* Brand category is required"),
  });


  // new brand request schema
  export const brandSchema = yup.object().shape({
    brand: yup.string().required("* Brand name is required"),
    // brandLogo: yup.mixed().required("* Brand logo is required"),
    brandOwner: yup.string().required("* Brand owner is required"),
    brandCategory: yup.string().required("* Brand category is required"),
  });